import Component from "../ui/Component"

const DomHelper = function () {
  // Check so it doesn't break headless test environments
  if (typeof window !== 'undefined')
    this.doc_ = window.document
}

DomHelper.prototype.createElement = function (tagName, props, ...children) {
  var ele = this.doc_.createElement(tagName)
  if (props) DomHelper.applyAttributesToElement(ele, props)
  DomHelper.appendChildrenToElement(this.doc_, ele, children)
  return ele
}

DomHelper.prototype.createElementNS = function (
  namespaceURI,
  tagName,
  props,
  ...children
) {
  var ele = this.doc_.createElementNS(namespaceURI, tagName)
  if (props) DomHelper.applyAttributesToElement(ele, props)
  DomHelper.appendChildrenToElement(this.doc_, ele, children)
  return ele
}

DomHelper.prototype.getDocument = function () {
  return this.doc_
}

DomHelper.applyAttributesToElement = function (ele, props) {
  var propKeys = Object.keys(props)
  for (var i = 0; i < propKeys.length; i++) {
    var key = propKeys[i]
    ele.setAttribute(key, props[key])
  }
}

DomHelper.appendChildrenToElement = function (doc, ele, children) {
  for (var i = 0; i < children.length; i++) {
    var child = children[i]
    if (typeof child === "string" || typeof child === "number")
      child = doc.createTextNode(String(child))
    if (child instanceof Component) {
      var element = child.getElement()
      if (!element) {
        child.createDom()
        child = child.getElement()
        if (!child)
          throw new Error("Component has no element after calling createDom.")
      } else {
        child = element
      }
    }
    ele.appendChild(child)
  }
}

export default DomHelper
